// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer___BXuG","calendarButtons":"ClockData_calendarButtons__3Fqyj"};